import * as React from "react";
import * as _ from "lodash";
import {
  IActualListeningProps,
  IActualListeningState,
  ArticleItem,
} from "./IActualListening.types";
import { ToggleBox } from "../ToggleBox/ToggleBox";
import { ToggleBoxGroup } from "../ToggleBoxGroup/ToggleBoxGroup";
import { CurrentEvent } from "../CurrentEvent/CurrentEvent";
import { SelectBox } from "../FormControls/SelectBox";

export class ActualListening extends React.Component<
  IActualListeningProps,
  IActualListeningState
> {
  private searchField: HTMLInputElement;
  static defaultProps = {
    limit: 12,
    numberOfItemsToAddOnLoadMore: 6,
    loadMoreText: "Ladda mer",
    showNumberOfHits: false,
  };
  constructor(props: IActualListeningProps) {
    super(props);
    this.state = {
      firstItems: this.props.ArticleItemList,
      secondItems: this.props.ArticleItemList,
      itemChecked: {},
      limit: this.props.limit,
      checkedClass: "",
      LoadMoreHidden: false,
    };
  }
  componentDidMount() {
    var radioButtons = document.querySelectorAll("input[name='filtergroup']");
    if (radioButtons.length > 0) {
      var radioButton = radioButtons[0] as HTMLInputElement;
      radioButton.checked = true;
    }
  }

  componentDidUpdate(prevProps, prevState) {
    this.setFocus(prevState.limit);
  }

  selectedItem = (e: any) => {
    let itemChecked = this.state.itemChecked;

    itemChecked = {};
    const value = e.value;
    const checked = e.isTouched;

    const itemCheckedClone = _.cloneDeep(itemChecked);
    itemCheckedClone[value] = checked;

    this.setState({
      itemChecked: _.mapKeys(itemCheckedClone, (value, key) => {
        return key;
      }),
    });
  };
  //Filters
  checkItem = (e: React.ChangeEvent<HTMLInputElement>) => {
    let itemChecked = this.state.itemChecked;

    if (e.currentTarget.type === "radio") itemChecked = {};
    const value = e.currentTarget.value;
    const checked = e.currentTarget.checked;

    const itemCheckedClone = _.cloneDeep(itemChecked);
    itemCheckedClone[value] = checked;

    this.setState({
      itemChecked: _.mapKeys(itemCheckedClone, (value, key) => {
        return key;
      }),
    });
  };

  hideLoadMore = () => {
    var limitCount = this.state.limit;
    var totalItems = this.props.ArticleItemList.length;
    var diffrence = totalItems - limitCount;
    if (diffrence > 0 && diffrence >= 3) {
      return this.setState({
        LoadMoreHidden: false,
      });
    } else {
      return this.setState({
        LoadMoreHidden: true,
      });
    }
  };

  renderfirstItems = () => {
    const firstItems = this.state.firstItems;
    const itemChecked = this.state.itemChecked;

    return firstItems
      .filter((item) => {
        if (this.nothingChecked()) {
          return true;
        }

        if (item.TagList.length === 0) {
          return false;
        }

        return item.TagList.some((cat) => {
          const itemFound = this.itemIsFound(itemChecked, cat);

          return !!itemFound;
        });
      })
      .slice(0, 6)
      .map(this.renderFirstArticleItems);
  };

  renderSecondItems = () => {
    const { secondItems, itemChecked } = this.state;

    return secondItems
      .filter((item) => {
        if (this.nothingChecked()) {
          return true;
        }

        if (item.TagList.length === 0) {
          return false;
        }

        return item.TagList.some((cat) => {
          let itemFound = this.itemIsFound(itemChecked, cat);

          return !!itemFound;
        });
      })
      .slice(6, this.state.limit)
      .map(this.renderSecondArticleItems);
  };

  //If Item is Found return the filtered list
  private itemIsFound(itemChecked, cat: string) {
    var found = false;
    Object.keys(itemChecked).find((key) => {
      if (key === cat || key === "Alla områden" || key === "Alla") {
        var valueIsTrue = itemChecked[key];
        if (valueIsTrue) {
          return (found = true);
        } else {
          return (found = false);
        }
      } else {
        return (found = false);
      }
    });
    return found;
  }

  //If no filter is clicked
  nothingChecked = () => {
    const itemChecked = this.state.itemChecked;
    for (let k in itemChecked) {
      if (itemChecked.hasOwnProperty(k) && itemChecked[k]) {
        return false;
      }
    }
    return true;
  };

  //Load more
  onLoadMore = () => {
    this.setState({
      limit: this.state.limit + this.props.numberOfItemsToAddOnLoadMore,
    });

    this.hideLoadMore();
  };
  setFocus = (limit: number) => {
    var contentList = document.querySelectorAll(".contentlist-link");
    if (contentList.length > 0) {
      var item = contentList[limit] as HTMLAnchorElement;
      if (item) {
        item.focus();
      }
    }
  };
  renderCheckbox = () => {
    return (
      <fieldset>
        <legend className="sr-only">Kategorier</legend>
        <div className="page-list__filters">
          {this.props.categoryListFilter.map((category, i) => {
            return (
              <ToggleBox
                key={`aktuelltfilterbox-${i}`}
                label={category}
                value={category}
                onChangeCb={this.checkItem}
              />
            );
          })}
        </div>
      </fieldset>
    );
  };
  renderFilterListBox = () => {
    const selectBoxItems = this.getSelectBoxItems(
      this.props.categoryListFilter
    );
    return (
      <div className="filter-list__box">
        <ToggleBoxGroup
          categoryNames={this.props.categoryListFilter}
          onChangeCb={this.checkItem}
        />
        <label
          htmlFor="filtergroup-select-box"
          className="sr-only d-block d-md-none"
        >
          Välj filter
        </label>
        <SelectBox
          options={selectBoxItems}
          onChange={this.selectedItem}
          id="filtergroup-select-box"
          disableDefaultOption={true}
          fieldName="filtergroup-select"
          className="d-block d-md-none col-lg-4 col-md-6 col-sm-12"
        />
      </div>
    );
  };

  renderFirstArticleItems = (item: ArticleItem, index: number): JSX.Element => {
    return (
      <React.Fragment key={item.Id}>
        <CurrentEvent
          url={item.Url}
          imageUrl={item.ImageUrl}
          headline={item.Heading}
          date={item.Date}
          timeDateFormat={item.TimeDateFormat}
          text={item.Text}
          lowresBase64={item.LowresBase64}
          externalImage={item.ExternalImage}
          cssClassArticle="actuall-lisning__first-items col-lg-4 col-md-6 col-sm-12"
          cssClassText="actuall-lisning__text"
          Id={item.Id}
          ImageDescription={item.ImageDescription}
          useH2Heading={true}
        />
      </React.Fragment>
    );
  };

  renderSecondArticleItems = (
    item: ArticleItem,
    index: number
  ): JSX.Element => {
    return (
      <div key={item.Id + "_second"} className="actuall-lisning__second-items">
        <div className="actuall-lisning__second-items-container">
          <time
            dateTime={
              item.TimeDateFormat != null ? item.TimeDateFormat : item.Date
            }
          >
            {item.Date}
          </time>
          <div className="actuall-lisning__second-items-textcontainer">
            <h2 className="heading-small">
              <a className="contentlist-link" href={item.Url}>
                {item.Heading}
              </a>
            </h2>
            <div className="">{item.Text}</div>
          </div>
        </div>
      </div>
    );
  };

  searchSubmit = (e: React.SyntheticEvent<HTMLElement>): void => {
    e.preventDefault();
    var searchTerm = this.searchField.value;
    var articleItemList = this.props.ArticleItemList.filter((item) => {
      return (
        item.Heading.toLowerCase().indexOf(searchTerm.toLowerCase()) !== -1
      );
    });

    return this.setState({
      firstItems: articleItemList,
      secondItems: articleItemList,
    });
  };
  getSelectBoxItems = (categories) => {
    let selectBoxItems = [];
    for (var cat of categories) {
      var selectboxItem = { key: cat, text: cat };
      selectBoxItems.push(selectboxItem);
    }
    return selectBoxItems;
  };
  render(): JSX.Element {
    let secondItems: JSX.Element[];
    const {
      searchId,
      hideSearch,
      useRadioButtons,
      loadMoreText,
      limit,
      showNumberOfHits,
      noHitsMessage,
    } = this.props;
    const listLength = limit - 6;
    let positiveveNumber =
      Math.sign(this.props.ArticleItemList.length - this.state.limit) === -1
        ? false
        : true;
    let firstItemsLength = this.renderfirstItems().length;
    let secondItemsLength = this.renderSecondItems().length;
    return (
      <div>
        <div className="row">
          {!hideSearch ? (
            <div className="col-lg-6">
              <form
                onSubmit={this.searchSubmit}
                role="search"
                aria-label="Sök inom aktuella händelser"
              >
                <span className="search">
                  <label htmlFor={searchId} className="sr-only">
                    Ange söktext
                  </label>
                  <input
                    id={searchId}
                    onChange={this.searchSubmit}
                    type="search"
                    ref={(ref) => (this.searchField = ref)}
                    placeholder="Sök"
                  />
                  <input
                    aria-label="Sök"
                    className="search__button"
                    type="submit"
                    value=""
                  />
                </span>
              </form>
            </div>
          ) : null}
          <div className="col-lg-12">
            {!useRadioButtons
              ? this.renderCheckbox()
              : this.renderFilterListBox()}
            {showNumberOfHits ? (
              <div className="d-flex">
                <div className="d-flex justify-content-end filter-list__count">
                  <span aria-live="polite">
                    Visar {firstItemsLength + secondItemsLength} av{" "}
                    {this.props.ArticleItemList.length}
                  </span>
                </div>
              </div>
            ) : null}
            {noHitsMessage ? (
              <div aria-live="polite">
                {firstItemsLength == 0 && secondItemsLength == 0 ? (
                  <p className="no-hits-message">{noHitsMessage}</p>
                ) : null}
              </div>
            ) : null}
          </div>
          <div
            className="actuall-lisning__first-section col-lg-12"
            role="log"
            aria-atomic="false"
          >
            {this.renderfirstItems()}
          </div>
          <div
            className="actuall-lisning__second-section"
            role="log"
            aria-atomic="false"
          >
            {(secondItems = this.renderSecondItems())}
          </div>
        </div>

        {!this.state.LoadMoreHidden &&
          positiveveNumber &&
          secondItems.length >= listLength && (
            <button className="page-list__load-more" onClick={this.onLoadMore}>
              {loadMoreText} (
              {this.props.ArticleItemList.length - this.state.limit} kvar)
            </button>
          )}
      </div>
    );
  }
}
